import BackgroundPattern from "./BackgroundPattern";
export default BackgroundPattern;